function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.74 2.04L13.37 2c.22 0 .56.07.75.17 0 0-.12-.14.06.05l3.62 3.74c.07.07.03.04.03.04.09.2.15.54.15.77v9.57c0 .7-.85 1.66-1.66 1.66l-12.67-.03c-.81 0-1.6-.63-1.64-1.61-.04-.99.04-11.84.04-12.7 0-.85.69-1.62 1.69-1.62zm-.18 1.78l.01 12.11c0 .22.18.4.4.4l12.07.07a.4.4 0 00.4-.4l-.01-9.04a.54.54 0 00-.15-.34l-2.92-2.84c-.08-.07-.15-.05-.15.06v3.52c0 .33-.46.92-.88.92H6.28c-.46 0-.96-.48-.96-.92V3.84a.2.2 0 00-.2-.2l-1.36-.01a.2.2 0 00-.2.2zm3.25.05v2.78c0 .11.1.2.2.2h4.48a.2.2 0 00.2-.2V3.87a.2.2 0 00-.2-.2H7a.2.2 0 00-.2.2z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.98 9.2a3.31 3.31 0 013.19 3.17 3.17 3.17 0 01-3.1 3.15c-1.65-.02-3.28-1.47-3.28-3.15s1.57-3.2 3.2-3.18zm-1.62 3.13c0 .97.77 1.69 1.63 1.68.85 0 1.58-.71 1.58-1.67a1.6 1.6 0 10-3.2-.02z",
  clipRule: "evenodd"
});

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.0a974f69.svg";
export { ForwardRef as ReactComponent };